/* globals currentProductTypeId, siteurl */

import Vue from 'vue';
import axios from 'axios';
import * as common from './common';

const axiosInstance = axios.create({
  baseURL: siteurl,
  timeout: 10000,
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
});
new Vue({
  el: '#other-sizes-dialog',
  data: {
    formats: [],
    productTypes: [],
    selectedProductType: {},
    withWoodenFrame: 0,
  },
  watch: {},
  methods: {
    outputFormat(format) {
      const underscoreFormat = format.replace(':', '_');
      return `format-${underscoreFormat}`;
    },
    sizeRow(size) {
      return size.show_size;
    },
    /*
    hasFrame() {
      console.log(this.selectedProductType.has_frame);
      return this.selectedProductType.has_frame;
    },
    */
    setInitialProductType() {
      const initialProductType = currentProductTypeId || 5;
      this.selectedProductType = this.productTypes.find(item => item.id === initialProductType);
    },
    isSelected(productTypeId) {
      return productTypeId === this.selectedProductType.id;
    },
    productPrice(size) {
      return common.formatPrice(size.price);
    },
    changeProduct() {
      //this.productType = this.selectedProductType;
      this.getProductsData();
    },
    getProductTypesList() {
      axiosInstance.get('ajax/getProductTypesList')
        .then((response) => {
          this.productTypes = response.data;
          this.setInitialProductType();
          this.getProductsData();
        });
    },
    getProductsData() {
      axiosInstance.get(
        'ajax/productTypeSizesList',
        {
          params: {
            product_type_id: this.selectedProductType.id,
            frame: this.withWoodenFrame,
          },
        },
      )
        .then((response) => {
          this.formats = response.data.formats;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    hasFrame() {
      return this.selectedProductType.has_frame;
    },
  },
  mounted() {
    this.getProductTypesList();
    //this.changeProduct();
  },
});
Vue.config.devtools = true;

